(function () {
  function formatTaxInYen(cents) {
    return Math.round((Number(cents) || 0) * 1.1 / 100).toLocaleString('ja-JP');
  }

  function fixFeaturedListOriginalPrice() {
    document.querySelectorAll('[bss-b2b-featured-product]').forEach(function (el) {
      var box = el.closest('.slider_item_price, .cat_item_price, .lineup_item_price, .cart_item_price, td.tax_in');
      if (!box) return;
      var vat = box.querySelector('.bss-b2b-collection-item-vat');
      var compare = box.querySelector('.bss-b2b-customized-compare-at-price');
      var ours = box.querySelector('.bbnet-list-original-tax-in');
      if (ours && vat && vat.hasAttribute('bss-b2b-cp')) {
        if (compare) compare.style.setProperty('display', 'none', 'important');
        ours.style.removeProperty('display');
        ours.style.textDecoration = 'line-through';
        return;
      }
      if (compare && vat && !compare.getAttribute('data-bbnet-tax-in-fixed')) {
        var cents = vat.getAttribute('data-collection-item-variant-price');
        if (!cents) return;
        var taxInLabel = box.matches('td.tax_in') ? '' : '（税込）';
        compare.textContent = '¥' + formatTaxInYen(cents) + taxInLabel;
        compare.setAttribute('data-bbnet-tax-in-fixed', '1');
      }
    });
  }

  document.addEventListener('bss_b2b_doneCheckCp', fixFeaturedListOriginalPrice);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(fixFeaturedListOriginalPrice, 300);
    });
  } else {
    setTimeout(fixFeaturedListOriginalPrice, 300);
  }
  setTimeout(fixFeaturedListOriginalPrice, 1500);
  setTimeout(fixFeaturedListOriginalPrice, 3000);
})();

if (typeof BSS_B2B !== 'undefined' && BSS_B2B) {
  if (window.location.pathname.includes('/cart')) {
    setTimeout(() => {
      try {
        var $storeData = $('#bss-b2b-store-data');
        if (!$storeData.length || !$storeData.html()) return;
        BSS_B2B.cp.changeProductPrice(JSON.parse($storeData.html()), false, false, false);
      } catch (err) {
        console.warn('[bss-custom] changeProductPrice skipped:', err);
      }
    }, 3000);
  }

  window.addEventListener('cart_changed', () => {
    setTimeout(() => {
      try {
        var $storeData = $('#bss-b2b-store-data');
        if (!$storeData.length || !$storeData.html()) return;
        var storeData = JSON.parse($storeData.html());
        BSS_B2B.cart.fixer(storeData, null, false);
      } catch (err) {
        console.warn('[bss-custom] cart.fixer skipped:', err);
      }
    }, 500);
  });

  // 連打防止 + チェックアウト遷移
  // 旧実装は preventDefault 後に Loading 表示するだけで遷移しておらず、
  // BSS B2B 側の customTriggerCheckoutBtn 呼び出しが来ないと永遠に進めなかった。
  setTimeout(() => {
    function handleButtonClick(e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      if ($button.data('bss-checkout-busy')) return;
      $button.data('bss-checkout-busy', true);

      var oldText = $button.text();
      $button.css({ 'pointer-events': 'none', opacity: '0.6' });
      $button.text('Loading ...');

      var goCheckout = function () {
        try {
          if (typeof BSS_B2B.customTriggerCheckoutBtn === 'function') {
            BSS_B2B.customTriggerCheckoutBtn($button[0]);
            return;
          }
        } catch (err) {
          console.warn('[bss-custom] customTriggerCheckoutBtn failed:', err);
        }
        window.location.href = '/checkout';
      };

      // 二重送信防止のため短時間待ってから遷移
      setTimeout(goCheckout, 300);

      // 遷移に失敗した場合にボタンを復帰
      setTimeout(function () {
        $button.data('bss-checkout-busy', false);
        $button.css({ 'pointer-events': 'unset', opacity: '1' });
        $button.text(oldText);
      }, 5000);
    }

    $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500);

  BSS_B2B.customTriggerCheckoutBtn = function () {
    window.location.href = '/checkout';
  };
}
